
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { ProvidersService } from '../_services/providers.service';
import { Component, OnInit, Provider, ViewChild } from '@angular/core';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PhoneService } from '../../phone/_services/phone.service';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-providers-list',
    templateUrl: './providers-list.component.html',
    host: { class: 'list-page' },
    standalone: false
})
export class ProvidersComponent implements OnInit {
  
  public providers: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData:any = {
    phoneNumber: null,
    callerId: null
  }

  constructor(
    private storage: LocalStorageService,
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private router: Router,
    private topbarService: TopbarService,
    private loginService: LoginService,
    private providersService: ProvidersService,
    private phoneService:PhoneService,
    private dialogService:DialogService,
    
  ) {
   
  }

  ngOnInit(): void {  
    this.topbarService.setTitle("Proveedores");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowWrite = this.loginService.hasPermission("PROVIDERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("PROVIDERS.DELETE");
  }
    
  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params:IParamsCollection = {      
      page: { number: $event.first+1, size: $event.rows },
      include: ['address']
    }
    
    if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.providersService.all(params));
    this.providers = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }
  
  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(provider: any) {
    //if (this.loginService.hasPermission("PROVIDERS_WRITE")) {      
      this.router.navigate(['providers/' + (provider && Object.keys(provider).length > 0 ? provider.id : 0)]);
    //}
  }

  delete(provider: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el proveedor?",
        header: "Eliminar proveedor",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.providersService.delete(provider.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Proveedor eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  getSeverity(active: boolean) {
    if(active){
      return 'success'; 
    }else{
      return 'danger';
    }    
  }

  showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId:string|null){
    this.phoneOverlayPanelData.phoneNumber = phoneNumber;
    this.phoneOverlayPanelData.callerId = callerId;
    this.phoneOverlayPanel?.show($event);
  }


  call(phoneNumber:string|undefined, callerId:string|null, caseId:string|null = null, caseServiceId:string|null = null){
    if(phoneNumber){
     this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
    }
  }

  addComunication(comunicationType:string|null, email:string|null, phoneNumber:string|null, provider:Provider) {
      let ref = this.dialogService.open(ComunicationsComponent, {
        closable: true,
        modal: true,
        header: 'Enviar comunicación',
        width: '60%',
        data: {
          caseId: null,
          model: provider,
          comunicationType: comunicationType,
          email: email,
          phoneNumber: phoneNumber
        }
      });
      ref.onClose.subscribe((data: any) => {
        //do nothing
      });
    }

  mail(email:string|undefined, provider:Provider){
    if(email){
     this.addComunication('Mail', email, null, provider);
    }
  }

}
